// extracted by mini-css-extract-plugin
export var commonSearches = "search-suggestions-list-module--commonSearches--xBZym";
export var darkHover = "search-suggestions-list-module--DarkHover--NLWOw";
export var title = "search-suggestions-list-module--title--7REFq";